import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import { Link } from "react-router-dom";


const UnitCountTwo = ({data}) => {

  return (
    <div className="col-xxl-12">
      <div className="row gy-4">
        <Link to={'/jobs/total'} className="col-xxl-3 col-sm-6">
        <div >
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                    <Icon icon="hugeicons:briefcase-01" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Total Jobs
                    </span>
                    <h6 className="fw-semibold">{data.totalJobs || 0}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Link >
          <Link to={'/jobs/new'} className="col-xxl-3 col-sm-6">
        <div className="">
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="hugeicons:briefcase-01" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      New Jobs
                    </span>
                    <h6 className="fw-semibold">{data?.newJobs || 0}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          </Link>
          <Link to={'/jobs/active'}  className="col-xxl-3 col-sm-6"> 
          
        <div>
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-3">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-yellow text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="hugeicons:briefcase-01" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Active Jobs
                    </span>
                    <h6 className="fw-semibold">{data?.activeJobs || 0}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          </Link>
          <Link to={'/staff'} className="col-xxl-3 col-sm-6">
        <div >
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-4">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-purple text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="mdi:users" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Total Staff
                    </span>
                    <h6 className="fw-semibold">{data?.totalStaff}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Link>
        <Link to={'/invoices'} className="col-xxl-3 col-sm-6">
        <div >
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-5">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-pink text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="hugeicons:invoice-03" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Invoices
                    </span>
                    <h6 className="fw-semibold">{data?.totalInvoices || 0}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Link>
     
      </div>
    </div>
  );
};

export default UnitCountTwo;
